module.exports = __webpack_public_path__ + "08d2ba95211911242e4045f402d25550.pdf";